import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleResult',
  props: {
    requestResult: null
  },
  emits: ['sendRequest'],
  setup(__props: any, { emit }) {

const props = __props as {
    requestResult: string;
};





const handleSubmit = () => {
    emit('sendRequest');
};

return { __sfc: true,props, emit, handleSubmit }
}

})